"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NativeEvent =
/** @class */
function () {
  function NativeEvent(name) {
    this.name = name;
    this.callbacks = [];
  }

  NativeEvent.prototype.registerCallback = function (callback) {
    this.callbacks.push(callback);
  };

  NativeEvent.prototype.unRegisterCallback = function (callback) {
    var index = this.callbacks.findIndex(function (eventCallback) {
      return eventCallback === callback;
    });
    this.callbacks.splice(index, 1);
  };

  NativeEvent.prototype.resetCallbacks = function () {
    this.callbacks = [];
  };

  return NativeEvent;
}();

var NativeEventHandler =
/** @class */
function () {
  function NativeEventHandler() {
    this.events = {
      callNative: new NativeEvent('callNative'),
      callJavaScript: new NativeEvent('callJavaScript')
    };
  }

  NativeEventHandler.prototype.dispatchEvent = function (name, payload) {
    this.events[name].callbacks.forEach(function (callback) {
      return callback(payload);
    });
  };

  NativeEventHandler.prototype.on = function (name, callback) {
    this.events[name].registerCallback(callback);
  };

  NativeEventHandler.prototype.off = function (name, callback) {
    this.events[name].unRegisterCallback(callback);
  };

  NativeEventHandler.prototype.removeAllListeners = function () {
    Object.values(this.events).forEach(function (event) {
      return event.resetCallbacks();
    });
  };

  return NativeEventHandler;
}();

exports.NativeEventHandler = NativeEventHandler;